import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useGetPageElementQuery, useUpdatePageContentMutation } from '../../../api/pageElementApiSlice';
import Title from '../../../components/Title';
import Tabs from '../../../components/Tabs';
import get from 'lodash/get';
import { Button } from 'react-bootstrap';
import Icon from '../../../components/Icon';

const TabElement = ({initialValue, lang}) => {
  const [content, setContent] = useState(initialValue)
  const page_element_id = useParams()["id"];
  const [update] = useUpdatePageContentMutation()
  const [isEditable, setIsEditable] = useState(false)
  const { t } = useTranslation();

  const onCancel = ()=>{
    setIsEditable(false)
    setContent(initialValue)
  }
  const onSubmit = ()=>{
    update({
      page_element_id,
      content,
      language_code: lang
    })
  }
  useEffect(() => {
    setContent(initialValue)
  }, [initialValue])

  return (
    <>
      <Title group={false}>
        {isEditable && <Button key="submit" type="submit" variant="primary" onClick={onSubmit}>
          <Icon icon='save' text={t("save")} />
        </Button>}
        {isEditable && <Button key="onCancel" variant="secondary" onClick={onCancel}>
          <Icon icon='cancel' text={t("cancel")} />
        </Button>}
        {!isEditable && <Button key="edit" variant="primary" onClick={()=>(setIsEditable(true))}>
          <Icon icon='edit' text={t("edit")}/>
        </Button>}
      </Title>
      <ReactQuill theme="snow" value={content} onChange={setContent} readOnly={!isEditable} />
    </>
  )
}

const PageElement = () => {
  const id = useParams()["id"];
  const history = useHistory();
  const onBack = () => history.push(`/page_elements`)
  const {data = {}, isSuccess, isLoading } = useGetPageElementQuery(id)
  const langs = useMemo(() => Object.keys(get(data, 'page_content', {})), [data])
  const [content, setContent] = useState({})
  const setContentFromData = () => {
    let res = {id: id}
    Object.entries(data.page_content).forEach(([lang, val])=>{
      res[lang] = {
        id: val.id,
        language_id: val.language_id,
        content: val.content,
      }
    })
    setContent( res )
  }
  useEffect(() => {
    if (isSuccess) {
      setContentFromData()
    }
  }, [data])

  if( !isSuccess ) { return ( <></> ) }

  return (
    <>
      <Title main={data.label} sub={data.name} onBack={onBack}/>
      <Tabs>
        { langs.map((lang)=>(
          <TabElement
            key={lang}
            initialValue={content[lang]?.content}
            lang={lang}
            as={lang}
            icon={'edit'}
          />
        )) }
      </Tabs>
    </>
  )
}

export default PageElement;
